import {Injectable} from '@angular/core';

@Injectable()
export class LabelFormatService {

    extractNumberLabel(value: string) {
        const newString = Number(value);
        if (isNaN(newString) === true) { return value; } else { return newString.toString(); }
    }

    clampLabel(value: string, maxLength: number, ending: string) {
        if (value === undefined) {
            return '';
        } else {
            let string = '';
            for (let i = 0; i < maxLength; i++) {
                string += value.charAt(i);
            }
            string += ending;
            return string;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/service/labelFormatService.service.ts